import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { Observable } from "rxjs";
import { HttpHeaders, HttpParams } from "@angular/common/http";
import { PatientScoreTransDto } from "../../../interfaces/masters/scoreconfigmst";

@Injectable()
export class PatientScoreConfigMstApi{
 constructor(private api: HttpService) {}


 getByName<type>(url:string,queryparams:HttpParams):Observable<type> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryparams});
  }

  get(url:string,queryparams:HttpParams): Observable<PatientScoreTransDto[]>{
    let header=new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryparams});
  }

  add(url:string, data: PatientScoreTransDto): Observable<PatientScoreTransDto[]>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  update(url:string, data: PatientScoreTransDto,queryparams:HttpParams): Observable<PatientScoreTransDto[]>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.put( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params:queryparams});
  }
}